/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get */
import Controller from '@ember/controller';
import { computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
import { findBy, mapBy } from '@linc-technologies/linced-common/utils/arrays';

export default class EnrolmentYearLevelController extends Controller {
  @computed('model.genderField.options.[]')
  get genderOptions() {
    let options = this.get('model.genderField.options');
    if (isEmpty(options)) {
      return [
        { value: 'M', label: 'Male' },
        { value: 'F', label: 'Female' },
      ];
    }
    return options;
  }

  @computed('model.people.[]', 'genderOptions.[]', 'sortProp', 'sortDir')
  get yearLevels() {
    let yearLevels = [];
    let genderValues = mapBy(this.genderOptions, 'value');
    let genderCounts = genderValues.reduce((counts, gender) => {
      counts[gender] = 0;
      return counts;
    }, {});

    this.model.people.forEach((person) => {
      let learnerYearLevel = parseInt(person.currentYearLevel, 10);
      if (Number.isNaN(learnerYearLevel)) {
        // If we didn't parse successfully, it's probably empty.  Just use the raw value.
        learnerYearLevel = person.currentYearLevel;
      }

      let yearLevel = findBy(yearLevels, 'year', learnerYearLevel);

      if (!yearLevel) {
        yearLevel = Object.assign({ year: learnerYearLevel }, genderCounts);

        yearLevels.push(yearLevel);
      }

      yearLevel[person.gender]++;
    });

    return yearLevels.map((yearLevel) => {
      yearLevel.total = genderValues.reduce((count, gender) => {
        return count + yearLevel[gender];
      }, 0);

      return yearLevel;
    });
  }
}
